/* prettier-ignore */
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ToolsService } from '../services/tools.service';

export const plannerModeGuard: CanActivateFn = () => {
  const tools = inject(ToolsService);
  const router = inject(Router);

  if (tools.isPlannerMode())
    return router.parseUrl('/register-user');

  return true;
};
